var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg03Map(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8611 18.0485C11.9827 17.8578 12.1661 17.7158 12.377 17.634C15.7393 16.3297 18.123 13.0633 18.123 9.24023C18.123 4.26967 14.0936 0.240234 9.12305 0.240234C4.15248 0.240234 0.123047 4.26967 0.123047 9.24023C0.123047 13.0631 2.50652 16.3293 5.86849 17.6338C6.07933 17.7156 6.26273 17.8575 6.38433 18.0482L8.27965 21.0202C8.67275 21.6366 9.57283 21.6366 9.96593 21.0202L11.8611 18.0485Z",
    fill: "#E7E6F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.46099 9.34125C5.75389 9.04836 6.22876 9.04836 6.52165 9.34125L8.11264 10.9322L12.5321 6.51282C12.825 6.21993 13.2998 6.21993 13.5927 6.51282V6.51282C13.8856 6.80572 13.8856 7.28059 13.5927 7.57349L8.11264 13.0536L5.46099 10.4019C5.1681 10.109 5.1681 9.63415 5.46099 9.34125V9.34125Z",
    fill: "#6B57EA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg03Map);
export default __webpack_public_path__ + "static/media/03_map.fee07dd846a2922475b19957d3eac8ba.svg";
export { ForwardRef as ReactComponent };